<template>
    <b-col lg="6">
        <div class="form-item form-item-text"
             :class="{ 'field-error': errors.has('stp_login') && showErrors }">
            <label for="payout_stp_login"
                   class="form-label">
                STP login
            </label>
            <input id="payout_stp_login"
                   name="stp_login"
                   type="text"
                   v-model="fieldValue"
                   v-validate
                   data-vv-rules="required|max:255"
                   data-vv-as="STP login"
                   :disabled="sending">
            <p class="field-error--description"
               v-show="errors.has('stp_login') && showErrors">{{ errors.first('stp_login') }}</p>
        </div>
    </b-col>
</template>

<script>
    export default {
        inject: ['$validator'],
        props: ['sending', 'showErrors', 'setValue'],
        data () {
            return {
                fieldValue: ''
            }
        },
        watch: {
            fieldValue () {
                this.setValue('identifier', this.fieldValue);
            }
        }
    }
</script>


// WEBPACK FOOTER //
// src/components/layout/partials/section/content/payout/stp/StpLogin.vue